import { ArrowLeftIcon, ArrowRightIcon, CheckCircleIcon, InfoIcon } from '@icons';
import { Box, useTheme } from '@mui/material';
import { useIsMobile } from '@hooks';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import fourthTipImage from '@assets/fourthTipImage.png';
import secondTipImage from '@assets/secondTipImage.png';
import thirdTipImage from '@assets/thirdTipImage.png';
import SignUpCarouselSlide from '../SignUpCarouselSlide';
import { NavigationButton, PaginationButton, ProceedAppButton, ProceedAppButtonBox, StyledImg } from './styles';

const SignUpCarouselTips: React.FC = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useIsMobile();

  const slides = [
    {
      title: 'signup.carousel.firstSlide.title',
      titleImage: <InfoIcon
        color={theme.palette.primary.dark}
        style={{width: '64px', height: '64px', marginTop: '16px', marginBottom: '16px'}}
      />,
      topDescription: 'signup.carousel.firstSlide.topDescription',
      bottomDescription: 'signup.carousel.firstSlide.bottomDescription',
    },
    {
      title: 'signup.carousel.secondSlide.title',
      descriptionImage: <StyledImg src={secondTipImage} alt="Tip image" />,
      topDescription: 'signup.carousel.secondSlide.topDescription',
      bottomDescription: 'signup.carousel.secondSlide.bottomDescription',
    },
    {
      title: 'signup.carousel.thirdSlide.title',
      descriptionImage: <StyledImg src={thirdTipImage} alt="Tip image" />,
      topDescription: 'signup.carousel.thirdSlide.topDescription',
      bottomDescription: 'signup.carousel.thirdSlide.bottomDescription',
    },
    {
      title: 'signup.carousel.fourthSlide.title',
      descriptionImage: <StyledImg src={fourthTipImage} alt="Tip image" style={{width: '130px', marginTop: '50px', marginBottom: '50px'}} />,
      topDescription: 'signup.carousel.fourthSlide.topDescription',
      bottomDescription: 'signup.carousel.fourthSlide.bottomDescription',
    },
    {
      title: 'signup.carousel.fifthSlide.title',
      descriptionImage: <CheckCircleIcon
        color={theme.palette.primary.dark}
        style={{width: '100px', height: '100px', marginTop: '50px', marginBottom: '50px'}}
      />,
      topDescription: 'signup.carousel.fifthSlide.topDescription',
    },
  ];

  return (
    <Box>
      <Box>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {!isMobile && (
            <NavigationButton className="arrow-left" startIcon={<ArrowLeftIcon />}>
              <FormattedMessage id="signup.carousel.navigation.button.prev" />
            </NavigationButton>
          )}
          <Swiper
            slidesPerView={1}
            spaceBetween={10}
            pagination={{ el: '.swiper-pagination', type: 'bullets', clickable: true }}
            navigation={{
              nextEl: '.arrow-right',
              prevEl: '.arrow-left',
            }}
            modules={[Pagination, Navigation]}
            style={{ maxWidth: '600px', display: 'flex', alignItems: 'center', textAlign: 'center' }}
          >
            {slides.map((slide, index) => (
              <SwiperSlide key={index}>
                <SignUpCarouselSlide
                  number={index + 1}
                  titleId={slide.title}
                  titleImage={slide.titleImage}
                  descriptionImage={slide.descriptionImage}
                  topDescriptionId={slide.topDescription}
                  bottomDescriptionId={slide.bottomDescription}
                />
              </SwiperSlide>
            ))}
          </Swiper>
          {!isMobile && (
            <NavigationButton className="arrow-right" endIcon={<ArrowRightIcon />}>
              <FormattedMessage id="signup.carousel.navigation.button.next" />
            </NavigationButton>
          )}
        </Box>
        <PaginationButton component="div" className="swiper-pagination" />
      </Box>
      <ProceedAppButtonBox>
        <ProceedAppButton color="primary" onClick={() => navigate('/submission-creation')}>
          <FormattedMessage id="signup.carousel.proceedApp.button.title" />
        </ProceedAppButton>
      </ProceedAppButtonBox>
    </Box>
  );
};

export default SignUpCarouselTips;
